import { useEffect } from 'react';

/**
 * Dynamically updates the document title and og:title meta-tag based on search
 * state (searchTerm and current page number)
 */
export const useDocumentMeta = ({ resultSearchTerm, current, searchName }) => {
  useEffect(() => {
    let title;

    const isFirstPage = !current || current <= 1;
    const hasSearchTerm = resultSearchTerm && resultSearchTerm.trim() !== '';

    if (isFirstPage && !hasSearchTerm) {
      // Default title for the first page with no search
      title = `${searchName} | Historic England`;
    } else if (isFirstPage && hasSearchTerm) {
      // First page with search term
      title = `Searching ${resultSearchTerm} - ${searchName} | Historic England`;
    } else if (!isFirstPage && !hasSearchTerm) {
      // Later pages without search term
      title = `Page ${current} - ${searchName} | Historic England`;
    } else {
      // Later pages with search term
      title = `Searching ${resultSearchTerm} - Page ${current} - ${searchName} | Historic England`;
    }

    document.title = title;

    const metaTag = document.querySelector('meta[property="og:title"]');

    if (metaTag) {
      metaTag.setAttribute('content', title);
    }
  }, [resultSearchTerm, current, searchName]);
};
